import { createElement } from "@max/max";
import { getFullScreenSize } from "@/utils/layout";
import ModalBaseContainer from '@max/leez-modal-base-container';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import LImage from '@max/leez-image';
import TopView from '@max/leez-top-view';
import LinearGradient from '@hfe/max-linear-gradient';
import './index.scss';
export default function NoticePopup(props) {
    const { fullScreenHeight } = getFullScreenSize();
    return <TopView>
      <ModalBaseContainer visible={props.visible} contentStyle={{
        width: '750rpx',
        height: fullScreenHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    }}>
        
        <LImage source={{
        uri: 'https://p0.meituan.net/ingee/3ae8d37a44435af5230f2620f8c5cffa29359.png'
    }} style={{
        width: '341rpx',
        height: '126rpx'
    }}></LImage>
        <LImage source={{
        uri: 'https://p0.meituan.net/ingee/979e98b0ea7ed672ba26d5b95827b7368474.png'
    }} style={{
        width: '564rpx',
        height: '512rpx',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative'
    }}>
          
          <View className="notice-popup-card">
            
            <Text className="notice-popup-title">离免单只差一点</Text>

            
            <Text className="notice-popup-description">快去邀人打Call，冲榜赢免单！</Text>

            
            <View onClick={props === null || props === void 0 ? void 0 : props.onInviteCall}>
              <LinearGradient start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }} colors={['#FFE74D', '#FFDD00']} className='notice-popup-button'>
                <Text className="notice-popup-text">邀好友来打Call</Text>
              </LinearGradient>
            </View>
          </View>
        </LImage>

        
        <LImage onPress={props.onClose} source={{
        uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
    }} style={{
        width: '48rpx',
        height: '48rpx',
        marginTop: '60rpx'
    }} className="notice-popup-close-btn"/>
      </ModalBaseContainer>
    </TopView>;
}
